import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './contact.css';
export default function Contact() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <>
      <div><Navbar /></div>
      <div className="container">

        <section className="header-section">
          <h1>Contact Us</h1>
          <p>We're Here to Help!</p>
        </section>

        <section className="contact-info-section">
          <h2>Get in Touch with Us</h2>
          <p className="contact-info">
            <i className="fas fa-map-marker-alt"></i>
           22A, Kumaran Colony,<br />
            1st Street,Saidapet,<br />
            Chennai-600015.
          </p>
          <p className="contact-info">
            <i className="fas fa-phone"></i>
            Phone: +91 9176849803
          </p>
          {/* <p className="contact-info">
            <i className="fas fa-envelope"></i>
            Email: contact@harihomecare.com
          </p> */}
          <p className="contact-info">
            Our team is available Monday to Saturday, from 9 AM to  7 PM. Don't hesitate to reach out with any questions or to schedule a service!
          </p>
        </section>

        <section className="map-section">
          <h2>Our Location</h2>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d312045.38506847995!2d80.17555565053568!3d13.059150661682886!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5260f3a9190b73%3A0x9f1c4a06c6e0208a!2sNo.8%2C%20Anna%20Nagar%208th%20Street%2C%20Anna%20Nagar%2C%20Chennai%2C%20Tamil%20Nadu%20600024!5e0!3m2!1sen!2sin!4v1633359425112!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            title="Our Location"
          ></iframe>
        </section>
      </div>
      <div><Footer /></div>
    </>
  );
}
